import React from "react";

const DocumentsRequired = () => {
  return <div>Documents Required for Admission</div>;
};

export default DocumentsRequired;
